const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withAnimateScroll = require("../../core/hoc/withAnimateScroll");
const AT = require("../../core/vault/ActionTypes");
const OpsCart = require("../vault/OpsCart");
const StoreUtil = require("../../../shared/StoreUtil");
const Information = require("./Information");

const OrderSummary = require("./OrderSummary");
const ContactInfo = require("./ContactInfo");
const styles = require("./styles/PayPalInfo.css");
const ShippingMethod = require("./ShippingMethod");

// This view handles PayPal orders. If they require shipping, we collect that info
// and use it to calculate taxes, otherwise we collect the billing info to calculate
// taxes, even though they're using PayPal Express.

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withAnimateScroll(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "ShippingInfo",

		propTypes: {
			cart: PT.object.isRequired,
			onContinue: PT.func,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateScroll: PT.func.isRequired,
		},

		getValidation: function() {
			const {cart} = this.props;
			return OpsCart.getGroupedStepValidation(cart, "paypalinfo");
		},

		componentDidMount: function() {
			this.alreadyScrolledToError = true;
		},

		componentDidUpdate: function(prevProps, prevState) {
			if (this.alreadyScrolledToError) return;
			const cart = this.props.cart;
			const validation = this.getValidation();
			const ef = _.keys(validation.errorTypes);
			const contactFields = _.keys(OpsCart.getFormSection(cart, "contact"));
			const billingFields = _.keys(OpsCart.getFormSection(cart, "billing"));
			if (ef.length) {
				this.alreadyScrolledToError = true;
				if (_.intersection(ef, contactFields).length) {
					this.props.animateScroll({
						scrollThing: this.contactSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				} else if (_.includes(ef, "agreeRecurring") && this.acceptSection) {
					this.props.animateScroll({
						scrollThing: this.acceptSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				} else if (_.intersection(ef, billingFields).length) {
					this.props.animateScroll({
						scrollThing: this.billingSection,
						timeRatio: 0.65,
						maxTime: 1000,
					});
				}
			}
		},

		updateField: function(field, val) {
			if (OpsCart.needsShipping(this.props.cart)) {
				this.props.dispatch({
					type: AT.UPDATE_CART_FORMDATA,
					section: "shipping",
					vals: {[field]: val},
				});
			} else {
				this.props.dispatch({
					type: AT.UPDATE_CART_FORMDATA,
					section: "billing",
					vals: {[field]: val},
				});
			}
		},

		onContinue: function() {
			// Throttling done to fix T11411.
			this.doSubmit =
				this.doSubmit ||
				_.throttle(
					() => {
						const cart = this.props.cart;
						const validation = this.getValidation();

						if (validation.isComplete) {
							const canGoToNext = OpsCart.hasAlreadyPreparedOrder(cart);

							if (canGoToNext) {
								this.props.onContinue();
							} else {
								this.props.dispatch({type: AT.PREPARE_ORDER_REQUEST});
							}
						} else {
							this.alreadyScrolledToError = false;
							this.props.dispatch({type: AT.SHOW_ALL_CHECKOUT_VALIDATION});
						}
					},
					500,
					{leading: true, trailing: false}
				);
			this.doSubmit();
		},

		render: function() {
			const {cart} = this.props;
			const validation = this.getValidation();

			const invalidAddressGroup = validation.invalidAddressGroup;
			const showError = OpsCart.needsShipping(cart)
				? invalidAddressGroup || !_.isEmpty(validation.errorTypes)
				: !_.isEmpty(validation.errorTypes);

			let addressSectionTitle = null;
			let addressSection = null;
			let shippingMethod = null;
			let preventContinue = null;

			if (OpsCart.needsShipping(cart)) {
				const items = cart.items || [];
				const booksOnly =
					items.length > 0 &&
					StoreUtil.getBookItems(items).length === items.length;
				const shippingInfo = OpsCart.getFormSection(
					this.props.cart,
					"shipping"
				);

				const getPriceForMethod = method => {
					return OpsCart.calculateShippingPriceWithMethod(
						this.props.cart,
						method
					);
				};

				addressSectionTitle = (
					<div className={styles.title}>{"Shipping Information"}</div>
				);

				addressSection = (
					<Information
						values={_.omit(shippingInfo, ["method"])}
						updateField={this.updateField}
						initialTabIndex={4}
						errorFields={validation}
						invalidAddressGroup={invalidAddressGroup}
						addressType={"shipping"}
						splitName={booksOnly}
					/>
				);

				shippingMethod = (
					<ShippingMethod
						shippingInfo={shippingInfo}
						getPriceForMethod={getPriceForMethod}
						validation={validation}
						updateField={this.updateField}
					/>
				);

				preventContinue = OpsCart.needsShippingToBlockedAddress(cart);
			} else {
				// show Billing Info section
				const billingInfo = OpsCart.getFormSection(cart, "billing");

				const errorFields = this.getValidation();

				addressSectionTitle = (
					<div className={styles.title} ref={c => (this.creditSection = c)}>
						{"Billing Information"}
					</div>
				);

				addressSection = (
					<Information
						values={billingInfo}
						initialTabIndex={4}
						updateField={this.updateField}
						errorFields={errorFields}
						className={styles.information}
						invalidAddressGroup={errorFields.invalidAddressGroup}
						addressType={"billing"}
					/>
				);
			}

			let showParts = ["phone", "email"];
			if (OpsCart.hasCodeItems(cart.items)) {
				showParts = ["phone", "your email"];
			}

			return (
				<div className={styles.main}>
					<div className={styles.title}>{"Contact Information"}</div>
					<div className={styles.across}>
						<div className={styles.formContainer}>
							<ContactInfo
								contactInfo={OpsCart.getFormSection(cart, "contact")}
								subscribeOnCheckout={cart.subscribeOnCheckout}
								errorFields={validation}
								initialTabIndex={1}
								showParts={showParts}
							/>
							{addressSectionTitle}
							<div>
								{addressSection}
								{shippingMethod}
							</div>
						</div>
						<OrderSummary
							cart={cart}
							showItemize={true}
							onContinue={this.onContinue}
							showError={showError}
							buttonText="Continue"
							paypalButtonText={"Switch to"}
							tabIndex={500}
							preventContinue={preventContinue}
						/>
					</div>
				</div>
			);
		},
	})
);
